// Creates an element for viewing corrections.
class CorrectionsViewer extends CorrectorWidget {

	///////////////////////////////////////////////////////////////////////////////////////////
	//  CONSTRUCTOR
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	CONSTRUCTOR: Creates an instance of the Viewer object.
	This will create the @element from the @html.element string and set up all events.

	options - An Object literal containing options.

	Examples:

	// Creates a new viewer, adds a custom field and displays an correction.
	viewer = new CorrectionsViewer()
	viewer.addField({
		load: someLoadCallback
	})
	viewer.load(correction)

	Returns a new Viewer instance.
	*/
	constructor(options) {
		// TODO: Can't use 'this' before super, so have to declare html local and use that, then set the class property
		const element = `\
<div class="corrector-outer corrections-viewer">
  <ul class="corrector-widget corrector-listing"></ul>
</div>\
`;
		// Configuration options
		const defaultOptions = { readOnly: true };// Start the viewer in read-only mode. No controls will be shown.

		super( $(element)[0], $.extend(defaultOptions, options) );
	}

	properties() {
		super.properties();

		// Events to be bound to the @element.
		this.events = this.events || {};
		this.events = $.extend(this.events, {
			".corrector-edit click":   "onEditClick",
			".corrector-delete click": "onDeleteClick"
		});

		// Classes for toggling corrections state.
		this.classes = this.classes || [];
		this.classes = $.extend(this.classes, {
			hide: 'corrector-hide',
			showControls: 'corrector-visible'
		});

		// HTML templates for @element and @item properties.
		this.html = this.html || {};
		this.html = $.extend(this.html, {
			element: `\
<div class="corrector-outer corrections-viewer">
  <ul class="corrector-widget corrector-listing"></ul>
</div>\
`,// See constructor
			item: `\
<li class="corrector-correction corrector-item">
  <span class="corrector-controls">
    <a href="#" title="View as webpage" class="corrector-link">View as webpage</a>
    <button type="button" title="Edit" class="corrector-edit">Edit</button>
    <button type="button" title="Delete" class="corrector-delete">Delete</button>
  </span>
</li>\
`
		});

		this.item = $(this.html.item)[0];
		this.fields = [];
		this.corrections = [];
	}

	///////////////////////////////////////////////////////////////////////////////////////////
	//  PUBLIC METHODS
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	PUBLIC: Displays the Viewer and first the "show" event.
	Can be used as an event callback and will call Event#preventDefault() on the supplied event.

	event - Event object provided if method is called by event listener (default:undefined)

	Examples:

	// Displays the editor.
	viewer.show()

	// Displays the viewer on click (prevents default action).
	$('a.show-viewer').bind('click', viewer.show)

	Returns itself.
	*/

	show(event) {
		CorrectorUtil.preventEventDefault(event);

		const controls = this.element.find('.corrector-controls')
			.addClass(this.classes.showControls);

		setTimeout((() => controls.removeClass(this.classes.showControls)), 500)

		this.element.removeClass(this.classes.hide);

		return this.checkOrientation().publish('show');
	}

	/*
	PUBLIC: Checks to see if the Viewer is currently displayed.

	Examples:

	viewer.show()
	viewer.isShown() // Returns true

	viewer.hide()
	viewer.isShown() // Returns false

	Returns true if the Viewer is visible.
	*/
	isShown() {
		return !this.element.hasClass(this.classes.hide);
	}

	/*
	PUBLIC: Hides the Editor and fires the "hide" event.
	Can be used as an event callback and will call Event#preventDefault() on the supplied event.

	event - Event object provided if method is called by event listener (default:undefined)

	Examples:

	// Hides the editor.
	viewer.hide()

	// Hide the viewer on click (prevents default action).
	$('a.hide-viewer').bind('click', viewer.hide)

	Returns itself.
	*/

	hide(event) {
		CorrectorUtil.preventEventDefault(event);

		this.element.addClass(this.classes.hide);
		return this.publish('hide');
	}

	/*
	PUBLIC: Loads corrections into the viewer and shows it.
	Fires the "load" event once the viewer is loaded passing the corrections into the callback.

	correction - An Array of correction elements.

	Examples:

	viewer.load([correction1, correction2, correction3])

	Returns itslef.
	*/

	load(corrections) {
		this.corrections = corrections || [];

		const list = this.element.find('ul:first').empty();
		for (let correction of this.corrections) {
			let controller;
			const item = $(this.item).clone().appendTo(list).data('corrector', correction);
			const controls = item.find('.corrector-controls');

			const link = controls.find('.corrector-link');
			let edit = controls.find('.corrector-edit');
			let del  = controls.find('.corrector-delete');

			const links = new LinkParser(correction.links || []).get('alternate', {'type': 'text/html'});
			if ((links.length === 0) || (links[0].href == null)) {
				link.remove();
			}
			else {
				link.attr('href', links[0].href);
			}

			if (this.options.readOnly) {
				edit.remove();
				del.remove();
			}
			else {
				controller = {
					showEdit() { return edit.removeAttr('disabled'); },
					hideEdit() { return edit.attr('disabled', 'disabled'); },
					showDelete() { return del.removeAttr('disabled'); },
					hideDelete() { return del.attr('disabled', 'disabled'); }
				};
			}

			for (let field of this.fields) {
				const element = $(field.element).clone().appendTo(item)[0];
				field.load(element, correction, controller);
			}
		}

		this.publish('load', [this.corrections]);

		return this.show();
	}

	/*
	PUBLIC: Adds an addional field to an correction view.
	A callback can be provided to update the view on load.

	options - An options Object. Options are as follows:
		load - Callback Function called when the view is loaded with an correction. Recieves a newly created clone of @item and the correction to be displayed (it will be called once for each correction being loaded).

	Examples:

	// Display a user name.
	viewer.addField({
		//This is called when the viewer is loaded.
		load: function(field, correction){
			field = $(field)
			if (correction.user) {
				field.text(correction.user) // Display the user
			}
			else {
				field.remove() // Do not display the field.
			}
		}
	})

	Returns itself.
	*/

	addField(options) {
		const field = $.extend({
			load() {}
		}, options);

		field.element = $('<div />')[0];
		this.fields.push(field);
		//field.element; //  TODO: Why was this here?
		return this;
	}


	/*
	Fires an event of type and passes in the associated correction.

	event - An Event object.
	type  - The type of event to fire. Either "edit" or "delete".

	Returns nothing.
	*/
	onButtonClick(event, type) {
		const item = $(event.target).parents('.corrector-correction')
		this.publish(type, [item.data('corrector')])
	}

	///////////////////////////////////////////////////////////////////////////////////////////
	//  CALLBACK METHODS
	///////////////////////////////////////////////////////////////////////////////////////////

	/*
	Callback function: called when the edit button is clicked.

	event - An Event object.

	Returns nothing.
	*/
	onEditClick(event) {
		this.onButtonClick(event, 'edit');
	}

	/*
	Callback function: called when the delete button is clicked.

	event - An Event object.

	Returns nothing.
	*/
	onDeleteClick(event) {
		this.onButtonClick(event, 'delete');
	}


	///////////////////////////////////////////////////////////////////////////////////////////
	//  STATIC METHODS
	///////////////////////////////////////////////////////////////////////////////////////////

}

class LinkParser {

	constructor(data) {
		this.data = data;
	}

	get(rel, cond) {
		let k;
		if (cond == null) { cond = {}; }
		cond = $.extend({}, cond, {rel});
		const keys = ((() => {
			const result = [];
			for (k of Object.keys(cond)) {
				const v = cond[k];
				result.push(k);
			}
			return result;
		})());
		return (() => {
			const result1 = [];
			for (const d of this.data) {
				const match = keys.reduce(((m, k) => m && (d[k] === cond[k])), true);
				if (match) {
					result1.push(d);
				}
				else {
					continue;
				}
			}
			return result1;
		})();
	}
}
